<template>
  <div :class="[question.Source?.toLowerCase()]">
    <HomeBaseLabel :question="question" :class="[question?.LabelStyleClass]" />
    <div
      class="d-flex counter"
      :class="{ 'counter--disabled': disabled }"
      :data-uiid="question.DataUiid"
    >
      <v-btn
        :ripple="false"
        color="webgrey"
        class="elevation-0"
        :disabled="
          question.AnswerControlCounterOptions.Count ===
            question.AnswerControlCounterOptions.CountMinValue || disabled
        "
        @click="decreaseCounter"
        aria-label="Decrease counter"
      >
        <v-icon color="white">mdi-minus</v-icon>
      </v-btn>
      <v-card class="elevation-0">
        <label class="font-20 font-weight-bold">{{
          question.AnswerControlCounterOptions.CountValues[
            question.AnswerControlCounterOptions.Count
          ].DisplayValue
        }}</label>
      </v-card>
      <v-btn
        :ripple="false"
        color="webgrey"
        class="elevation-0"
        :disabled="
          question.AnswerControlCounterOptions.Count ===
            question.AnswerControlCounterOptions.CountMaxValue || disabled
        "
        @click="increaseCounter"
        aria-label="Increase counter"
      >
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "CounterBase",
  components: {
    HomeBaseLabel,
  },
  props: {
    question: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // sync value changes from outside the component
    "question.Value"() {
      this.syncValue();
    },
  },
  methods: {
    increaseCounter() {
      if (
        this.question.AnswerControlCounterOptions.Count <
        this.question.AnswerControlCounterOptions.CountMaxValue
      ) {
        this.question.AnswerControlCounterOptions.Count += 1;
        this.setValue();
      }
    },
    decreaseCounter() {
      if (
        this.question.AnswerControlCounterOptions.Count >
        this.question.AnswerControlCounterOptions.CountMinValue
      ) {
        this.question.AnswerControlCounterOptions.Count -= 1;
        this.setValue();
      }
    },
    setValue() {
      this.question.Value =
        this.question.AnswerControlCounterOptions.CountValues[
          this.question.AnswerControlCounterOptions.Count
        ].Value;
      this.question.Source = "User";
    },
    syncValue() {
      if (this.question.Value) {
        let counterOptionKey = null;
        const countValues =
          this.question.AnswerControlCounterOptions.CountValues;

        for (const key in countValues) {
          if (countValues[key].Value === this.question.Value) {
            counterOptionKey = key;
            break;
          }
        }

        if (!counterOptionKey) return;

        this.question.AnswerControlCounterOptions.Count = +counterOptionKey;
      } else {
        // No existing answer; set it to the counter value string
        this.setValue();
      }
    },
  },
  created() {
    this.syncValue();
  },
};
</script>

<style lang="scss" scoped>
.counter.counter--disabled {
  opacity: 0.6;
}
</style>
